// Validation utilities

export const validatePhoneNumber = (phone: string): boolean => {
  const phoneRegex = /^[0-9]\d{9}$/;
  return phoneRegex.test(phone);
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateOTP = (otp: string): boolean => {
  const otpRegex = /^\d{6}$/;
  return otpRegex.test(otp);
};

export const validateName = (name: string): boolean => {
  return name.trim().length >= 2;
};

export const validateRequired = (value: string): boolean => {
  return value.trim().length > 0;
};

export const getPhoneError = (phone: string): string | null => {
  if (!phone) return 'Phone number is required';
  if (phone.length !== 10) return 'Phone number must be 10 digits';
  if (!validatePhoneNumber(phone)) return 'Please enter a valid phone number';
  return null;
};

export const getEmailError = (email: string): string | null => {
  if (!email) return 'Email is required';
  if (!validateEmail(email)) return 'Please enter a valid email address';
  return null;
};

export const getNameError = (name: string): string | null => {
  if (!name) return 'Name is required';
  if (name.trim().length < 2) return 'Name must be at least 2 characters';
  return null;
};

export const getOTPError = (otp: string): string | null => {
  if (!otp) return 'OTP is required';
  if (otp.length !== 6) return 'OTP must be 6 digits';
  if (!validateOTP(otp)) return 'Please enter a valid OTP';
  return null;
};